import { IoIosSettings } from "react-icons/io";
import { HiDocumentText } from "react-icons/hi";
import { MdOutlineCampaign } from "react-icons/md";
import { RiChatForwardFill } from "react-icons/ri";
import { FaWallet } from "react-icons/fa";
import NavBarItem from "./NavBar/NavBarItem";
// import { UserContext } from "../../context/UserContext";
// import { useContext } from "react";
import { BsLink45Deg } from "react-icons/bs";
import { TbReportSearch } from "react-icons/tb";
import { FaFolderOpen } from "react-icons/fa";
import { FaWpforms } from "react-icons/fa6";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/UserContext";
import { axiosInstance } from "../../utils/networking";
import { Box, Stack } from "@mui/material";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
const NavBar = () => {
  const { user } = useContext(UserContext);
  const [openWebIntakeCount, setOpenWebIntakeCount] = useState(0);
  const [validationCount, setValidationCount] = useState(0);
  const [reminderCount, setReminderCount] = useState(0);

  useEffect(() => {
    const fetchOpenWebIntakeCount = async () => {
      const res = await axiosInstance.get("/webintake/openCount");
      if (res.status === 200) {
        setOpenWebIntakeCount(res.data.count);
      } else {
        console.log("API Error at getting open web intake count");
      }
    };
    fetchOpenWebIntakeCount();
  }, []);

  useEffect(() => {
    const fetchValidationCount = async () => {
      const res = await axiosInstance.get("/data_validation/count");
      if (res.status === 200) {
        setValidationCount(res.data.count);
      } else {
        console.log("API Error at getting open validation count");
      }
    };
    fetchValidationCount();
  }, []);

  console.log(user);
  return (
    <div className="p-2 flex flex-col">
      {user?.role === "admin" &&
        [
          "desanctisj@oaklandthrive.org",
          "garcias@oaklandthrive.org",
          "cookt@oaklandthrive.org",
          "williamst@oaklandthrive.org",
          "admin",
        ].includes(user.username) && (
          <Stack direction="row" sx={{ alignItems: "center" }} spacing={0}>
            <NavBarItem
              toURL={"/dashboard/webIntakeForms"}
              icon={<FaWpforms />}
              text={"Web Intake Forms"}
            />
            {openWebIntakeCount > 0 && (
              <Box
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {openWebIntakeCount}
              </Box>
            )}
          </Stack>
        )}

      <Stack direction="row" sx={{ alignItems: "center" }} spacing={0}>
        <NavBarItem
          newTab={true}
          toURL={"/dashboard/validations"}
          icon={<AssignmentIndIcon />}
          text={"Data Validations"}
        />
        {validationCount > 0 && (
          <Box
            sx={{
              backgroundColor: "red",
              color: "white",
              borderRadius: "50%",
              width: 20,
              height: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            !
          </Box>
        )}
      </Stack>
      <Stack direction="row" sx={{ alignItems: "center" }} spacing={0}>
        <NavBarItem
          toURL={"/dashboard"}
          icon={<HiDocumentText />}
          text={"Dashboard"}
        />
        {reminderCount > 0 && (
          <Box
            sx={{
              backgroundColor: "red",
              color: "white",
              borderRadius: "50%",
              width: 20,
              height: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 12,
              fontWeight: "bold",
            }}
          >
            {reminderCount}
          </Box>
        )}
      </Stack>
      <NavBarItem
        newTab={true}
        toURL={"https://linktr.ee/OaklandThriveMI"}
        icon={<BsLink45Deg />}
        text={"Internal Links"}
      />

      <NavBarItem
        toURL={"/dashboard/firms"}
        icon={<HiDocumentText />}
        text={"New Firm Visit Plan"}
      />
      <NavBarItem
        toURL={"/dashboard/exploreFirm"}
        icon={<FaWallet />}
        text={"Explore Firms"}
      />
      <NavBarItem
        toURL={"/dashboard/myreferrals"}
        icon={<RiChatForwardFill />}
        text={"My Referrals"}
      />
      <NavBarItem
        toURL={"/dashboard/providers"}
        icon={<FaWallet />}
        text={"B2B Providers"}
      />
      <NavBarItem
        toURL={"/dashboard/resources"}
        icon={<IoIosSettings />}
        text={"Resource Partners"}
      />
      <NavBarItem
        toURL={"/dashboard/events"}
        icon={<IoIosSettings />}
        text={"Events"}
      />
      <NavBarItem
        toURL={"/dashboard/glossary"}
        icon={<RiChatForwardFill />}
        text={"Glossary of Terms"}
      />

      <NavBarItem
        toURL={"/dashboard/reports"}
        icon={<TbReportSearch />}
        text={"Reporting"}
      />

      <NavBarItem
        toURL={"/dashboard/archivedcases"}
        icon={<FaFolderOpen />}
        text={"Archived Cases"}
      />
      <NavBarItem
        toURL={"/dashboard/broadcast"}
        icon={<MdOutlineCampaign />}
        text={"Broadcast Email"}
      />
    </div>
  );
};

export default NavBar;
